import {
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Subscription } from 'rxjs'
import { FILTER_MAP, TAX_EFFICIENCY_FILTERS } from 'src/app/models/filter-details.model'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { FiltersService } from 'src/app/services/filtersService.service'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'tax-efficiency-filter',
  templateUrl: './tax-efficiency-filter.component.html',
  styleUrls: ['./tax-efficiency-filter.component.scss'],
})
export class TaxEfficiencyFilterComponent implements OnInit, OnDestroy {
  popupDescription: string
  taxExemptURL: string

  // AEM content Vars
  taxManaged: AEMChunk
  taxExempt: AEMChunk
  aemContentSub: Subscription

  constructor(
    private readonly filtersService: FiltersService,
    private readonly centralContentService: CentralContentService,
  ) {}
  
  public readonly filterMap = FILTER_MAP
  public readonly taxEfficiencyFilterLabels: string[] = TAX_EFFICIENCY_FILTERS
  public taxEfficiencyGroup: UntypedFormGroup

  ngOnInit() {
    this.taxEfficiencyGroup = this.filtersService.activeFilters.taxEfficiency
    this.taxEfficiencyGroup.valueChanges.subscribe(() => {
      this.filtersService.applyFilters()
    })
    this.taxExemptURL = environment.taxExemptLink

    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )

    this.popupDescription =
      this.taxManaged.contentValue + this.taxExempt.contentValue
  }

  parseAEMContent(content) {
    {
      this.taxManaged = this.centralContentService.getContentByBody(
        'fund_definitions_tax_managed',
        content,
      )
      this.taxExempt = this.centralContentService.getContentByBody(
        'fund_definitions_tax_exempt',
        content,
      )
    }
  }
  formatFilterValue(val) {
    return val.replace(/_/g, ' ')
  }

  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }
}
